<template>
  <div>
    <b-modal
      id="delete-entry"
      ref="delete-entry"
      size="entry-delete"
      centered
      hide-footer
      hide-header
      @hide="onClose"
    >
      <div class="modal-head">
        <span class="modal-title">{{ label.get('delete_time_entry') }}</span>
      </div>
      <div class="content-wrapper">
        <div class="field-row">
          <p v-html="label.get('delete_modal_body', {name : label.get('time_entry_lowercase')})" />
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="cancel atto-btn"
          @click="onClose"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn delete"
          @click="deleteEntry"
        >
          {{ label.get('delete') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
    import TimesheetService from '../../features/timesheets/shared/TimesheetService';
    export default {
        name: "DeleteEntryComponent",
        props: {
            timesheet: {
              type: Object,
              default: () => {
                return {};
              }
            }
        },
        mounted(){
            this.$refs['delete-entry'].show();
        },
        methods: {
            deleteEntry(){
                TimesheetService.deleteEntry(this.timesheet.id).then((result) => {
                    this.$root.$emit('reloadData');
                    this.$root.$emit("onDeleteEntry", null);
                    this.$root.$emit("onEntryDeleted");
                }).catch(() => { });
            },
            onClose() {
                this.$root.$emit("onDeleteEntry", null);
            }
        }
    }
</script>

